import React, { useEffect, useState} from 'react';
import { 
  Modal,
  Form,
  Input,
  message,
  Select,
  Col,
  Row,
  Table,
  Button,
  InputNumber,
  DatePicker,
  Spin,
} from 'antd';
import { observer } from 'mobx-react';
import { http, addVisitLog, history } from 'libs';
import store from './store';
import styles from './index.module.less';
import { MinusCircleOutlined, UploadOutlined } from '@ant-design/icons'
import { DebounceSelect } from 'components';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import 'moment/locale/zh-cn';

export default observer(function IForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState({});
  const [projectItem, setProjectItem] = useState({});

  const { Option } = Select;
  const { TextArea } = Input;

  useEffect(()=>{
    let cloneRecord = cloneDeep(store.record);
    cloneRecord.applyDate = cloneRecord.applyDate?moment(cloneRecord.applyDate):null;
    cloneRecord.recyclDate = cloneRecord.recyclDate?moment(cloneRecord.recyclDate):null;
    cloneRecord.transportDate = cloneRecord.transportDate?moment(cloneRecord.transportDate):null;
    cloneRecord.chargeStartDate = cloneRecord.chargeStartDate?moment(cloneRecord.chargeStartDate):null;
    cloneRecord.storageDate = cloneRecord.storageDate?moment(cloneRecord.storageDate):null;
    setRecord(cloneRecord);
  },[store.record]);

  function handleSubmit() {
    let formData = form.getFieldsValue();
    if (!formData.deviceName) {
      message.error('设备名称不能为空！');
      return false;
    }
    if (!formData.projectId) {
      message.error('项目编号不能为空！');
      return false;
    }
    if (!formData.brand) {
      message.error('品牌不能为空！');
      return false;
    }
    if (!formData.factoryCode) {
      message.error('货号不能为空！');
      return false;
    }
    if (!formData.contactPerson) {
      message.error('目前对接人不能为空！');
      return false;
    }
    if (!formData.address) {
      message.error('存放地点不能为空！');
      return false;
    }
    if (formData.recyclAddress?.length>50) {
      message.error('回收地址不能超过50个字！');
      return false;
    }
    if (formData.receivAddress?.length>50) {
      message.error('接收地址不能超过50个字！');
      return false;
    }
    if (formData.remark?.length>50) {
      message.error('备注不能超过50个字！');
      return false;
    }
    formData = {
      ...store.record,
      ...formData,
      projectNo: projectItem.projectNo||record.projectNo,
      applyDate: (formData.applyDate && formData.applyDate.format("YYYY-MM-DD")) || null,
      storageDate: (formData.storageDate && formData.storageDate.format("YYYY-MM-DD")) || null,
      chargeStartDate: (formData.chargeStartDate && formData.chargeStartDate.format("YYYY-MM-DD")) || null,
      transportDate: (formData.transportDate && formData.transportDate.format("YYYY-MM-DD")) || null,
      recyclDate: (formData.recyclDate && formData.recyclDate.format("YYYY-MM-DD")) || null,
    }
    setLoading(true);
    let url = ''
    if (store.record.id) {
      url = '/javaApi/front/customerFixedAssets/editInfo'
      addVisitLog({
        pageName: '编辑客户固资',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: "EditCustomerFixedAssets",
        eventName: "编辑客户固资",
        content: JSON.stringify(formData),
      })
    }else{
      url = '/javaApi/front/customerFixedAssets/insertInfo'
      addVisitLog({
        pageName: '新建客户固资',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: "InsertCustomerFixedAssets",
        eventName: "新建客户固资",
        content: JSON.stringify(formData),
      })
    }
    http.post(url, formData)
    .then(() => {
      message.success('操作成功');
      store.formVisible = false;
      store.page = 1;
      store.pageSize = 10;
      store.pageTotal = 0;
      store.fetchRecords()
    }, () => setLoading(false))

  }

  return (
    <Modal
      visible
      maskClosable={false}
      closable={true}
      title={store.isEdit ? '编辑客户固资' : '新建客户固资'}
      onCancel={()=>store.formVisible = false}
      confirmLoading={loading}
      style={{
        top: 40,
      }}
      className={styles.modalContainer}
      onOk={handleSubmit}
      width={810}>
      {     store.formLoading?
          <Spin/>:
          <>
      <Form form={form} labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} size={'middle'} labelAlign={'right'} initialValues={record}>
        <h3 className='modal-title'><strong>必填信息</strong></h3>
        <Row >
          <Col span={12}>
              <Form.Item name="deviceSerialNo" label="序列号" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item required name="brand" label="品牌" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name="contactPerson" required label="目前对接人" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name="projectId" required label="项目编号">
                {/* <Input autoComplete="off" allowClear placeholder="请输入" /> */}
                <Select
                    showSearch
                    placeholder="请录入并选择"
                    value={store.projectList.length?record.projectId:record.projectNo}
                    onChange={(v,opt) => opt?setProjectItem(opt.item):setProjectItem({})}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {store.projectList.map(item => (
                      <Select.Option key={item.id} value={item.id} item={item}>
                        {item.projectNo}
                      </Select.Option>
                    ))}
                  </Select>
              </Form.Item>
            </Col>
          <Col span={12}>
              <Form.Item name="address" required label="存放地点" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name="factoryCode" required label="货号" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name='deviceName' required label="设备名称">
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
            </Col>
        </Row>
        <h3 className='modal-title'><strong>非必填信息</strong></h3>
        <Row >
            <Col span={12}>
              <Form.Item name='applyDate' label="申请日期">
                  <DatePicker
                      style={{width:'100%'}}
                      allowClear
                      placeholder="请选择" />
              </Form.Item>
              <Form.Item name="expressNo" label="物流单号" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name="transportNo" label="转运单号" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
             
              <Form.Item name="transportDate" label="转运日期">
                  <DatePicker
                      style={{width:'100%'}}
                      allowClear
                      placeholder="请选择" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name='customerAssetNo' label="客户固资编号" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name="storageDate" label="入库日期" >
                  <DatePicker
                      style={{width:'100%'}}
                      allowClear
                      placeholder="请选择" />
              </Form.Item>
              <Form.Item name="receivProjectNo" label="接收项目编号" >
                <Input autoComplete="off" allowClear placeholder="请输入" />
              </Form.Item>
              <Form.Item name="recyclDate" label="回收日期">
                  <DatePicker
                      style={{width:'100%'}}
                      allowClear
                      placeholder="请选择" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item name="recyclAddress" label="回收地址" >
                  <Input autoComplete="off" style={{width:'670px'}} allowClear placeholder="请输入，限50个字" />
                </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item name="receivAddress" label="接收地址" >
                  <Input autoComplete="off" style={{width:'670px'}} allowClear placeholder="请输入，限50个字" />
                </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item name="remark" label="备注" >
                  <TextArea style={{width:'670px'}} allowClear placeholder="请输入，限50个字" />
                </Form.Item>
            </Col>
          </Row>
      </Form>
      </>}
    </Modal>

  )
})